import blog1Img from '../assets/spices3.jpg';
import blog2Img from '../assets/kanda lasun.jpg';
import blog3Img from '../assets/jire masala.jpg';
import blog4Img from '../assets/garam masala.jpg';
import blog5Img from '../assets/velachi powder.jpg';
import blog6Img from '../assets/spices5.jpg';

export const blogPosts = [
  {
    id: 1,
    title: 'Secret Indian Spices That Make Every Dish Taste Better',
    excerpt: 'Beyond turmeric and cumin lies a world of "secret" aromatics that elevate a simple meal into a culinary masterpiece.',
    content: `
      In the vast landscape of Indian cuisine, certain spices act as silent orchestrators of flavor. While everyone knows turmeric and chilli, the true magic often lies in the "Secret Spices" that seasoned home cooks use to create depth.

      One such secret is "Stone Flower" (Dagad Phool). This lichen doesn't have much aroma when raw, but when dropped into hot oil, it releases a mysterious, earthy fragrance that defines many legendary Mughlai and Maharashtrian gravies. 

      Another hidden gem is "Nagkesar" (Cobra Saffron). It adds a woody, slightly peppery sweetness that is essential for authentic Goda Masala. These aren't just ingredients; they are the legacy of centuries-old culinary wisdom.

      At Ragini Masale, we've carefully curated these rare aromatics, ensuring that your kitchen has access to the same "secrets" that have made Indian royal cuisines world-famous.
    `,
    category: 'Secrets',
    date: 'May 10, 2024',
    author: 'Chef Ragini',
    img: blog1Img,
    featured: true
  },
  {
    id: 2,
    title: 'Traditional Maharashtrian Masalas That Still Rule Indian Kitchens',
    excerpt: 'From the smoky "Kanda Lasun" to the complex "Goda Masala," discover the blends that define the heart of Maharashtra.',
    content: `
      Maharashtrian cuisine is a beautiful balance of heat, earthiness, and subtle sweetness. At the heart of this balance are the legendary spice blends that have stood the test of time.

      Take "Kanda Lasun Masala"—a fiery blend of onions, garlic, and sun-dried chillies. It's the soul of the Kolhapuri Misal and the spicy 'Rassa'. Then there's "Goda Masala," a unique blend that uses coconut and stone flower to create a sweet-savory profile that is unlike anything else in India.

      These masalas aren't just about heat; they are about texture and aroma. The traditional "Paushti" (nutritional) approach ensures that every blend also aids in digestion and wellness.

      We take pride in preserving these authentic recipes, stone-grinding them exactly as they were made in the households of Sahyadri generations ago.
    `,
    category: 'Heritage',
    date: 'May 08, 2024',
    author: 'Anita Deshpande',
    img: blog2Img,
    featured: false
  },
  {
    id: 3,
    title: 'Why Homemade Masalas Taste Better Than Ready-Made Spices',
    excerpt: 'The hidden truth about industrial processing and why "Chakki-Fresh" will always be the king of flavor.',
    content: `
      Have you ever noticed that your grandmother's curry had an aroma that filled the entire street, while modern packets barely scent the kitchen? The reason isn't just nostalgia—it's science.

      Industrial masalas are often processed at extreme speeds, generating heat that "burns" off the volatile oils. Furthermore, to increase shelf life, many commercial brands use fillers and anti-caking agents that dilute the pure flavor.

      "Homemade" or traditional small-batch grinding (like our process at Ragini Masale) ensures that the oils remain intact. When spices are stone-ground slowly, the friction doesn't generate heat, preserving the 'Top Notes' of the aroma.

      Choosing pure, traditionally processed masalas is the easiest way to instantly double the flavor of your everyday cooking without changing a single recipe.
    `,
    category: 'Insight',
    date: 'May 05, 2024',
    author: 'Amit Sharma',
    img: blog3Img,
    featured: false
  },
  {
    id: 4,
    title: 'Top Indian Spices Every Kitchen Must Have',
    excerpt: 'Build your ultimate spice pantry with these 7 essentials that form the foundation of thousands of dishes.',
    content: `
      If you're starting your culinary journey, the sheer variety of Indian spices can be overwhelming. However, you don't need a hundred jars—you need the "Essential Seven."

      From the vibrant color of "Deghi Mirch" to the earthy depth of "Shahi Jeera," we break down the must-haves. Turmeric for health, Cloves for warmth, Cardamom for sweetness, and of course, the king of spices—Black Pepper.

      Each of these spices serves a purpose: some for color, some for aroma, and some for health. Understanding how to use them individually allows you to eventually master the art of blending.

      Our "Starter Collection" at Ragini Masale is designed to give you the highest-grade versions of these essentials, ensuring your pantry is built on a foundation of purity.
    `,
    category: 'Basics',
    date: 'April 28, 2024',
    author: 'Dr. Sameer Rao',
    img: blog4Img,
    featured: false
  },
  {
    id: 5,
    title: 'The Art Of Traditional Spice Grinding In Indian Culture',
    excerpt: 'Exploring the "Khal-Batta" and "Chakki"—ancient tools that are the real secret behind Indian culinary depth.',
    content: `
      Before the electric mixer, there was the "Khal-Batta" (Mortar and Pestle) and the "Pata-Varvanta" (Grinding Stone). These weren't just tools; they were the heart of the home.

      Grinding spices by hand is a sensory ritual. It allows the cook to control the texture—coarse for some dishes, silky fine for others. More importantly, the cold-grinding process prevents the oxidation of delicate spices like Coriander and Cumin.

      In this article, we look at why top chefs are returning to these ancient methods. The texture created by a stone grinder allows the spice to "release" its flavor slowly during cooking, rather than all at once.

      At Ragini Masale, we honor this culture by using automated versions of these traditional stone grinders, giving you the benefit of ancient wisdom with modern consistency.
    `,
    category: 'Culture',
    date: 'April 20, 2024',
    author: 'Chef Ragini',
    img: blog5Img,
    featured: false
  },
  {
    id: 6,
    title: 'How Pure Masalas Transform Everyday Cooking',
    excerpt: 'From basic Dal to everyday Sabzi, see how the quality of your spice blend makes the difference between "okay" and "extraordinary."',
    content: `
      Most people think that complex dishes require complex spices. But the truth is, even a simple bowl of yellow dal can be transformed into a gourmet experience if the masala is pure.

      Pure masalas have a "vibrancy"—the colors are brighter, and the flavors are more distinct. When you use high-quality, unadulterated spices, you actually need to use *less* quantity to achieve a *better* result.

      We've seen how families rediscover the joy of eating at home when they switch to traditionally processed masalas. The natural oils help in better digestion and leave you feeling satisfied without the heavy, oily feeling of restaurant food.

      It's time to stop settling for "standard" and start experiencing the transformative power of purity in your daily meals.
    `,
    category: 'Living',
    date: 'April 12, 2024',
    author: 'Anita Deshpande',
    img: blog6Img,
    featured: false
  }
];
